import React, { useState, useEffect } from "react";
import {
    Layout,
    theme,
    ConfigProvider,
    Row,
    Form,
    Typography,
    Col,
    Table,
    Input,
    Divider,
    Spin,
    Card,
    Breadcrumb,
    Collapse,
    Checkbox,
    Select
} from "antd";
import "../../../../assets/styles/DatePicker.css";
import CustomButton from "../../../../components/custom/CustomButton";
import FormDataTable from "./FormDataTable";
import { useNavigate } from "react-router-dom";
import { useForm } from "antd/es/form/Form";


const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const FormLayoutDataTable = ({ formTitle, disabled, setDisabled }) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState(null);


    const [form] = useForm();


    const onFinishForm = (values) => {
        console.log(values);
        setFormData(values);
    }

    function onCancel() {
        navigate("/sya1000", { replace: false });
    }

    // const onSubmit = (values) => {
    //     console.log("Success:", values);
    // };

    return (
        <Form layout="vertical" style={{ paddingTop: 20 }} onFinish={onFinishForm} form={form} initialValues={formData}>
            <Card
                style={{
                    boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                }}

                title={formTitle}
            >
                <Card
                    style={{
                        marginBottom: "3%",
                        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                    }}
                    bordered
                >
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                name="office"
                                label={<Text strong>Data table name</Text>}
                            >
                                <Select
                                    placeholder={"Please Select a value"}
                                    style={{ width: "30vh" }}
                                    showSearch
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="currency" label={<Text strong>Application table name</Text>}>
                                <Select
                                    placeholder={"Please Select a value"}
                                    style={{ width: "30vh" }}
                                    showSearch
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            {(formTitle === "Create Data table") &&
                                <Form.Item name="multiRow">
                                    <Checkbox>Multi Row</Checkbox>
                                </Form.Item>}
                            <div style={{ marginBottom: "25px" }}>
                                <FormDataTable
                                    disabled={disabled}
                                    setDisabled={setDisabled}
                                    form={form}
                                    formData={formData} />
                            </div>
                        </Col>
                    </Row>
                </Card>
                <Form.Item>
                    <Row>
                        <CustomButton
                            content="Submit"
                            style={{
                                width: "10%",
                                marginLeft: "auto",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            }}
                            htmlType="submit"
                            backgroundColor="#15CCAE"
                            colorText="black"
                            hoverBackground="#4FECA0"
                        />
                        <CustomButton
                            content="Cancel"
                            style={{
                                width: "10%",
                                marginLeft: "1%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            }}
                            backgroundColor="#fff"
                            colorText="black"
                            hoverBackground="#F5F5F5"
                            onClick={onCancel}
                        />
                    </Row>
                </Form.Item>
            </Card>
        </Form>
    )
}

export default FormLayoutDataTable